// extracted by mini-css-extract-plugin
module.exports = {"root":"InputLabel_root__ifipg","label":"InputLabel_label__WMM5o","disabled":"InputLabel_disabled__iIIvA","block":"InputLabel_block__oATMD"};